import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { IconTile } from "~/components/common/IconTile";
import { BriefcaseMedicalIcon } from "~/components/common/icons";
import type { ItemAction, ServiceItem } from "~/lib/types";

type Props = {
  item: ServiceItem;
  childCount: number;
  // Accepted for compatibility with the category drill-down; not shown here.
  // eslint-disable-next-line react/no-unused-prop-types
  primaryAction: ItemAction | null;
};

export const ServiceCategoryCard = ({ item, childCount }: Props) => {
  const { t } = useTranslation();

  return (
    <Link
      to={`/services/${item.item_key}`}
      className="flex flex-col rounded-xl border border-border-shell/60 dark:border-transparent bg-surface-blank p-6 shadow-simple transition hover:shadow-content"
    >
      <IconTile tone="accent">
        <BriefcaseMedicalIcon className="h-6 w-6" />
      </IconTile>

      <h3 className="mt-5 font-heading text-lg font-bold text-text-full">
        {item.item_name}
      </h3>
      {item.item_description && (
        <p className="mt-2 line-clamp-2 text-sm text-text-light">
          {item.item_description}
        </p>
      )}

      <div className="mt-auto border-t border-border-shell/60 pt-4 text-sm">
        {childCount > 0 ? (
          <span className="text-text-light">
            {t("ServicesPage.subcategories", { count: childCount })}
          </span>
        ) : (
          <span className="font-medium text-accent">
            {t("ServicesPage.view-providers")}
          </span>
        )}
      </div>
    </Link>
  );
};
